import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProjectCardProperties__documents" }

import { useClientStore } from "@/stores/clients";
import { useDocumentsStore } from "@/stores/documents";
import { computed, PropType } from "vue";
import commonTools from "@/tools/common-tools";
import { projectToSlug } from "@/tools/projects";
import { Project } from "@/types";
import Ok from "@/components/general/Ok.vue";
import { useRouter } from "vue-router";
import ProjectCardDocuments from "./ProjectCardDocuments.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCardProperties',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const clientsStore = useClientStore();
const documentsStore = useDocumentsStore();

const clientName = computed(() => {
    const client = clientsStore.getItemById(props.project.clientId);
    return client ? client.name : "";
});

const budget = computed(() => {
    const budget =
        props.project.hours * props.project.rate - props.project.discount;
    return commonTools.currencyFormat(budget);
});

const documents = computed(() => {
    return documentsStore.getDocumentsForProjectOfType(
        props.project.id,
        "invoice"
    );
});

const isPaidInvoice = computed(() => {
    if (
        props.project.projectStatus === 3 ||
        props.project.projectStatus === 4
    ) {
        let paid = true;
        for (let document of documents.value) {
            if (!document.paid) {
                paid = false;
            }
        }
        return paid;
    } else {
        return false;
    }
});

const select = () => {
    router.push({ name: "Project", params: { slug: slug.value } });
};

const slug = computed(() => {
    return projectToSlug(props.project, -1);
});

const status = computed(() => {
    return props.project.projectStatus === 2 && props.project.finished
        ? "2--ready"
        : props.project.projectStatus;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ background: 'var(--status-' + status.value + ')' }),
    class: "ProjectCardProperties"
  }, [
    _createElementVNode("div", {
      class: "ProjectCardProperties__name",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (select()))
    }, [
      _createTextVNode(_toDisplayString(slug.value) + " ", 1),
      (isPaidInvoice.value)
        ? (_openBlock(), _createBlock(Ok, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "ProjectCardProperties__client",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (select()))
    }, _toDisplayString(clientName.value), 1),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ProjectCardDocuments, {
        project: __props.project,
        doctype: 'invoice'
      }, null, 8, ["project"]),
      _createVNode(ProjectCardDocuments, {
        project: __props.project,
        doctype: 'quotation'
      }, null, 8, ["project"])
    ]),
    _createElementVNode("div", {
      class: "ProjectCardProperties__budget",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (select()))
    }, _toDisplayString(budget.value) + " " + _toDisplayString(__props.project.currency), 1)
  ], 4))
}
}

})